<template>
  <el-form label-position="right" label-width="80px" size="mini">
    <el-row style="margin:0;">
      <el-col :span="6">
        <el-form-item label="任务周期">
          <el-tag :style="tagStyle">{{ data.period?`${data.period}分`:"无数据" }}</el-tag>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="录音时长">
          <el-tag :style="tagStyle">{{ data.recording_length?`${data.recording_length}秒`:"无数据" }}</el-tag>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="创建时间">
          <el-tag :style="tagStyle">{{data.create_time?data.create_time:"无数据"}}
          </el-tag>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="任务说明">
      <el-tag :style="tagStyle">{{ data.detail?data.detail:"无说明" }}</el-tag>
    </el-form-item>
    <el-form-item label="扫描频率">
      <div v-if="data.freq_range && data.freq_range.length>0">
        <el-tag style="margin-right:1%" v-for="(value,key) in data.freq_range" :key="key" type="success" size="mini">
          {{parseFreqRange(value)}}
        </el-tag>
      </div>
      <el-tag v-else :style="tagStyle">无数据</el-tag>
    </el-form-item>
    <el-form-item label="白 名 单" label-width="75px">
    </el-form-item>
    <el-form-item label-width="0px">
      <div v-if='data.whitelist && JSON.stringify(data.whitelist) != "{}"'>
        <WhiteListOfTask :white-list-ids="data.whitelist"></WhiteListOfTask>
      </div>
      <el-tag v-else :style="tagStyle">无数据</el-tag>
    </el-form-item>
  </el-form>
</template>

<script>
  import WhiteListOfTask from "@/components/Tables/WhiteListOfTask";
  export default {
    props: ["periodTaskId"],
    components: {
      WhiteListOfTask
    },
    watch: {
      periodTaskId() {
        this.getData();
      }
    },
    mounted() {
      this.getData();
    },
    data() {
      return {
        taskVisible: false,
        data: {},
        tagStyle: "background-color:#fff;color:#999;height:22px;line-height:20px;"
      };
    },
    methods: {
      getData() {
        this.$getJSON("/task/s_period_tasklst", {
          options: [{
            type: "1",
            name: "id",
            value: this.periodTaskId
          }]
        }).then(res => {
          this.data = res.data[0];
        });
      },
      parseFreqRange(range) {
        if (range.length == 1) {
          return `${range[0]}`;
        } else {
          return `${range[0]}-${range[1]}`;
        }
      }
    }
  };

</script>

<style scoped>
  .el-form-item {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Form/PeriodTaskDetail.vue